<ms-khuyana-header [showHeading]="showHeading"></ms-khuyana-header>
<div class="wrap-content" [ngClass]="{ 'wrap-content__no-heading': !showHeading }">
  <router-outlet></router-outlet>
</div>